<template>
	<mw-dialog
		v-model="dialog"
		cancel-btn
		submit-btn
		@cancel="$emit('close')"
		@submit="submit"
	>
		<template v-slot:dialog-body>
			<p v-if="isPhone">
				The moderator will telephone you at the time of the appointment.
				Please contact Meisterworks if you have not received a phonecall.
			</p>
			<span v-else>
				<p v-if="isInternal">
					Start the appointment
				</p>
				<p v-else>
					<span v-if="haveLink">
						<span v-if="isVideo">
							You are starting a video appointment in a third party
							application. Press submit to continue
						</span>
						<span v-else>
							You will be taken to a third party application. Press
							submit to continue.
						</span>
					</span>
					<span v-else>
						There is no link associated with this appointment. Please
						contact meisterworks.
					</span>
				</p>
			</span>
		</template>
	</mw-dialog>
</template>

<script>
import MwDialog from "@c/ui/MwDialog";
export default {
	name: "ClickAppointment",
	props: {
		value: { type: String },
	},
	components: {
		MwDialog,
	},
	data: () => {
		return {
			dialog: false,
		};
	},
	computed: {
		appointment() {
			return this.$store.state.appointments.data[this.value];
		},
		appointmentParticipant() {
			return this.$store.getters.getByKey(
				"appointmentParticipants",
				"appointment",
				this.value
			)[0];
		},
		isInternal() {
			return this.appointment
				? this.appointment.video_medium == "internal"
				: false;
		},
		isVideo() {
			return this.appointment
				? this.appointment.methodology == "video"
				: false;
		},
		haveRoom() {
			if (!this.appointment) {
				return false;
			}
			return this.appointment.video_room ? true : false;
		},
		haveLink() {
			if (!this.appointment) {
				return false;
			}
			return this.appointment.participation_link ? true : false;
		},
		isPhone() {
			return this.appointment
				? this.appointment.methodology == "phone"
				: false;
		},
	},
	methods: {
		clickLink() {
			let link = this.appointment.participation_link;
			if (link.substr(0, 4) !== "http") {
				link = "http://" + link;
			}
			window.open(link, "_blank");
		},
		submit() {
			if (this.isInternal) {
				this.$router.push("/join/" + this.appointmentParticipant.id);
			} else {
				this.clickLink();
			}
			this.dialog = false;
		},
	},
	watch: {
		dialog(v) {
			if (!v) {
				this.$emit("close");
			}
		},
		value: {
			immediate: true,
			handler(v) {
				if (v) {
					this.dialog = true;
				}
			},
		},
	},
};
</script>
